<form [formGroup]="form" [ngClass]="{'invalid-submit': invalidSubmit}">
  <div class="ui-g-12 Loyalty">
    <div class="ui-g-12">
      <div class="ui-g-12 ui-md-4">
        <!-- Codice -->
        <span class="label">{{'report.code' | translate}}</span>
        <input type="text" pInputText formControlName="code" maxlength="50"/>
        <span class="input-error-notification" *ngIf="invalidSubmit && form.controls['code'].errors?.required">{{ 'common.required_error' | translate }}</span>
      </div>
      <div class="ui-g-12 ui-md-8">
        <!-- Descrizione -->
        <span class="label">{{'report.description' | translate}}</span>
        <input type="text" pInputText formControlName="description" maxlength="100"/>
      </div>
    </div>
    <div class="ui-g-12">
      <div class="ui-g-12 ui-md-4">
        <!-- store Total -->
        <span class="label">{{'report.storeTotal' | translate}}</span>
        <p-inputSwitch formControlName="storeTotal"></p-inputSwitch>

        <!-- chain Total -->
        <span class="label">{{'report.chainTotal' | translate}}</span>
        <p-inputSwitch formControlName="chainTotal"></p-inputSwitch>
      </div>
      <div class="ui-g-12 ui-md-8">
        <!-- Acm -->
        <span class="label">{{'common.acm' | translate}}</span>
        <p-dropdown [filter]="true" [options]="acmList" formControlName="acm" [style]="{ width: '100%' }"></p-dropdown>
      </div>
    </div>
    <div class="ui-g-12">
      <div class="ui-g-12 ui-md-6">
        <!-- Gruppo -->
        <span class="label">{{'storeGroupDetail.storeGroupDetail' | translate}}</span>
        <p-multiSelect [style]="{ width: '100%' }" [options]="storeGroupList" formControlName="storeGroup" (onChange)="onSelectionChange()" [disabled]="form.get('storeChain').value.length > 0"></p-multiSelect>
      </div>
      <div class="ui-g-12 ui-md-6">
        <!-- Catena -->
        <span class="label">{{'report.storeChain' | translate}}</span>
        <p-multiSelect [style]="{ width: '100%' }" [options]="storeChainList" formControlName="storeChain" (onChange)="onSelectionChange()" [disabled]="form.get('storeGroup').value.length > 0"></p-multiSelect>
      </div>
    </div>
    <div class="ui-g-12">
      <div class="ui-g-12 ui-md-6">
        <!-- Negozio -->
        <span class="label">{{'report.singleStore' | translate}}</span>
        <p-dropdown [options]="storeList" formControlName="store" [disabled]="form.get('storeGroup').value.length !== 1 && form.get('storeChain').value.length !== 1"></p-dropdown>
      </div>
      <div class="ui-g-12 ui-md-6"></div>
    </div>
    <div class="ui-g-12">
      <div class="ui-g-12 ui-md-4">
        <span class="label">{{'common.date_start' | translate}}</span>
        <!-- Data Inizio -->
        <app-kv-calendar
          #dateStartField
          [inputName]="'startDate'"
          [formData]="form"
          [startDateSelector]="true"
          [endDateInputName]="'endDate'"
          [endDateCalendar]="dateEndField"
        ></app-kv-calendar>
        <span class="input-error-notification" *ngIf="invalidSubmit && form.controls['startDate'].errors?.required">{{ 'common.required_error' | translate }}</span>
      </div>
      <div class="ui-g-12 ui-md-1"></div>
      <div class="ui-g-12 ui-md-4">
        <span class="label">{{'common.date_end' | translate}}</span>
        <!-- Data Fine -->
        <app-kv-calendar
          #dateEndField
          [inputName]="'endDate'"
          [formData]="form"
          [endDateSelector]="true"
          [startDateInputName]="'startDate'"
          [startDateCalendar]="dateStartField"
        ></app-kv-calendar>
        <span class="input-error-notification" *ngIf="invalidSubmit && form.controls['endDate'].errors?.required">{{ 'common.required_error' | translate }}</span>
      </div>
      <div class="ui-g-12 ui-md-3"></div>
    </div>
  </div>
  <div class="ui-g-12 text-right" style="margin: 20px 0;">
    <button
      type="button"
      pButton
      class="ui-button-success btnDelete"
      icon="fa fa-floppy-o"
      (click)="saveReport()"
      label="{{ 'customerSetBuilder.saveSet' | translate }}">
    </button>
    <button
      type="button"
      pButton
      class="ui-button-danger btnDelete"
      icon="fa fa-close"
      (click)="closeModal()"
      label="{{ 'common.cancel' | translate }}">
    </button>
  </div>
</form>



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-report-list/loyalty-report-form/loyalty-report-form.component.html